import React from 'react'
import { Button } from 'reactstrap'

import Layout from '../components/layout'
import FeaturedArticles from '../components/pages/index/FeaturedArticles'
import Billboard from '../components/Billboard'
import Offerings from '../components/Offerings'

import CloudServices from '../components/pages/professional-services/CloudServices'
import DevServices from '../components/pages/professional-services/DevServices'
import Seo from '../components/seo'
import people from "../images/home/people.svg";
import Clients from "../components/Clients";
import Testimonials from "../components/Testimonials";
import ClientsEmptySection from "../components/Clients/ClientsEmptySection";
import Process from "../components/Process";

const ProfessionalServicesPage = () => {
    const processRef = React.createRef()

    const scroll = () => {
        processRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

  return (
    <Layout>
      <Seo
        title="Professional Cloud Services For AWS"
        description="Our professional services team delivers across a wide range of AWS infrastructure and application services, including next-gen development projects."
      />

        <Billboard className="Billboard--homepage">
            <div className="Billboard__top">
                <div className="Billboard__prefix">transform your business with</div>
                <h1 className="Billboard__title">cloudnexa</h1>
                <div className="Billboard__lead">
                    Modernize your cloud experience with an AWS premier partner that
                    understands how businesses need to evolve.
                </div>

                <div className="Billboard__cta">
                    <Button className="btn-orange btn-lg" onClick={scroll}>
                        Let's Get Started
                    </Button>
                </div>
            </div>

            <div className="Billboard__people">
                <img src={people} alt="people background" width="630" height="358" />
            </div>
        </Billboard>

        <Offerings />
        <Process processRef={processRef} />
        <DevServices />
        <FeaturedArticles />
    </Layout>
  )
}

export default ProfessionalServicesPage
